module.exports = __webpack_public_path__ + "static/media/25.5784dcc3.jpg";